"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactive_google_map_1 = require("@dotdev/reactive-google-map");
var __1 = require("../");
var StoreLocatorMap = /** @class */ (function (_super) {
    __extends(StoreLocatorMap, _super);
    function StoreLocatorMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChangeBounds = function (bounds) {
            _this.context.storeLocator.updateQuery({
                position: _this.context.storeLocator.googleMapClient.mapGetCenter(),
                bounds: bounds,
                source: "map",
            });
        };
        return _this;
    }
    StoreLocatorMap.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactive_google_map_1.GoogleMap, __assign({ googleMapsApiVersion: this.context.storeLocator.options.googleMapsApiVersion, googleMapsApiKey: this.context.storeLocator.options.googleMapsApiKey, callback: this.context.storeLocator.setGoogleMapClient, mapOnClick: this.context.storeLocator.selectClear, mapOnDragEnd: this.handleChangeBounds, mapOnZoomChange: this.handleChangeBounds, mapOnFirstIdle: this.handleChangeBounds, markersOnClick: function (marker) { return _this.context.storeLocator.selectLocation(marker.id); }, infowindowMaxWidth: 300, infowindowOnClose: this.context.storeLocator.selectClear, infowindowContent: function (marker) { return (React.createElement(React.Fragment, null,
                "Marker ",
                marker.id)); }, markers: this.context.storeLocator.locations }, this.props)));
    };
    StoreLocatorMap.contextType = __1.Context;
    return StoreLocatorMap;
}(React.Component));
exports.StoreLocatorMap = StoreLocatorMap;
//# sourceMappingURL=store-locator-map.js.map